import TriggerRepository from "@/repositories/triggers/TriggerRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'trigger',
    namespaced: true,
    state: {
        ...makeState(),
        actions: []
    },
    getters: {
        ...makeGetters(),
        actions(state) {
            return state.actions
        }
    },
    mutations: {
        ...makeMutations(),
        setAllActions(state, array) {
            state.actions = array
        }
    },
    actions: {
        async listAll({commit}, params) {
            commit('setLoading', true)
            await TriggerRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.data)
            })
            commit('setLoading', false)
        },
        async listAllActions({commit}, params) {
            commit('setLoading', true)
            await TriggerRepository.listActions(params).then(response => {
                commit('setAllActions', response.data.data.data)
            })
            commit('setLoading', false)
        },
        async find({commit}, id) {
            commit('setLoading', true)
            await TriggerRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
